import type { GetPylonEmailHashResponse } from '@counsel-project/counsel-auth-api'
import { authRequest } from '../api/auth-api'

export const pylonIdentify = async (): Promise<GetPylonEmailHashResponse> => {
  return authRequest.user.pylon.getEmailHash({
    token: '',
  })
}
